import React, { useState, useEffect } from "react";
import { css } from "styled-components";
import throttle from "lodash/throttle";
import { Spacing } from "../helpers/layout";
import { Button } from "./Button";
import { MODAL_LEVEL } from "../helpers/zIndex";
import Router from "next/router";

export function OpenSeries(props: { slug: string }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const el = document.documentElement;
      const clientHeight = el.clientHeight;
      const scrollTop = document.body.scrollTop || el.scrollTop;
      const reachedPoint = scrollTop > clientHeight * 0.3;

      if (reachedPoint) {
        setShow(true);
      } else {
        setShow(false);
      }
    }, 200);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      css={css`
        position: sticky;
        bottom: -100px;
        padding: ${Spacing.xl} 0;
        text-align: center;
        z-index: ${MODAL_LEVEL - 1};
        padding-top: ${Spacing.xxl};
        transition: bottom 300ms;

        ${show &&
        css`
          bottom: 0px;
        `}
      `}
    >
      <div
        css={css`
          position: relative;
          top: 7px;
        `}
      >
        <Button
          type="button"
          label="See the complete series"
          onClick={() => {
            Router.push("/series/[slug]/shop", `/series/${props.slug}/shop`);
          }}
        />
      </div>
    </div>
  );
}
